module.exports = __webpack_public_path__ + "3ae53fa4130db133069f1eba0bcc8020.png";